import type { ContainerType } from "~/container";
import type { IApi } from "~/interfaces/IApi";
import type { IMaintenanceIssueService } from "@saif-reporting/domain/interfaces/services/IMaintenanceIssueService.js";
import type { Paginated } from "@saif-reporting/domain/dtos/Paginated.js";
import type { MaintenanceIssueListQuery, MaitenanceIssueCreateRequest } from "@saif-reporting/domain/dtos/maitenanceIsueDtos.js";
import { MaintenanceIssueDto } from "@saif-reporting/domain/dtos/models/MaintenanceIssueDto.js";
import { plainToClass } from "class-transformer";

export class MaintenanceIssueService implements IMaintenanceIssueService {
  private readonly baseApi: IApi;
  constructor({ baseApi }: ContainerType) {
    this.baseApi = baseApi;
  }

  async getList(query: MaintenanceIssueListQuery): Promise<Paginated<MaintenanceIssueDto>> {
    const res = await this.baseApi.$fetch<Paginated<MaintenanceIssueDto>>("/maintenance-issues", { query: query });
    return res;
  }

  async getOne(id: number): Promise<MaintenanceIssueDto> {
    const res = await this.baseApi.$fetch<MaintenanceIssueDto>(`/maintenance-issues/${id}`);
    return plainToClass(MaintenanceIssueDto, res);
  }

  async create(dto: MaitenanceIssueCreateRequest, images: File[]): Promise<MaintenanceIssueDto> {
    const formData = new FormData();
    formData.append("title", dto.title);
    formData.append("summary", dto.summary);
    dto.toEmails.forEach((te) => {
      formData.append("toEmails[]", te);
    });
    dto.ccEmails.forEach((ce) => {
      formData.append("ccEmails[]", ce);
    });

    images.forEach((img) => {
      formData.append("images", img);
    });

    const res = await this.baseApi.$fetch<MaintenanceIssueDto>(`/maintenance-issues`, { body: formData, method: "post" });
    return res;
  }

  async markAsCompleted(id: number): Promise<MaintenanceIssueDto> {
    const res = await this.baseApi.$fetch<MaintenanceIssueDto>(`/maintenance-issues/${id}/mark-as-completed`, { method: "patch" });
    return res;
  }

  async delete(id: number): Promise<MaintenanceIssueDto> {
    const res = await this.baseApi.$fetch<MaintenanceIssueDto>(`/maintenance-issues/${id}`, { method: "delete" });
    return res;
  }
}
